// AUTO-GENERATED by scripts/gen-version.js — do not edit by hand.
// Source of truth is package.json "version" (run via the prebuild/prestart hooks).
export const APP_VERSION = "2.22.0";
